/**
 * Created by HYL.
 * 角色相关api
 */
import * as API from './'

export default {

  //查询获取组织机构列表(通过page分页)
  findList: params => {
    return API.GET('/api/org/list', params)
  },
  getSelectOrg: params => {
    return API.GET('/api/org/getSelectOrg', params)
  },
  getOrgDetailFromOrgId:params=>{
    return API.GET('/api/org/getOrgDetailFromOrgId', params)
  },
  add: params => {
    return API.POST('/api/org/add', params)
  },
  
  update: params => {
    return API.POST('/api/org/update', params);
  },

  //单个删除组织机构信息
  remove: id => {
    return API.POST('/api/org/delete/' + id);
  },

  //
  tree: params => {
    return API.GET('/api/org/tree', params)
  },
  // 公司列表
  companyList: params => {
    return API.GET('/api/org/company', params)
  } 
}



// WEBPACK FOOTER //
// ./src/api/api_org.js